
declare global {
    function assert(condition: unknown, message?: string): asserts condition;
}

(globalThis as any).assert = function (condition: unknown, message = 'Assertion failed'): asserts condition {
    if (!condition) {
        throw new Error(message);
    }
};

import * as import_1 from ".\/prolog.js";
import * as import_2 from ".\/themes\/dmon\/scripts\/animations\/AbstractAnimation";
import * as import_3 from ".\/themes\/dmon\/scripts\/animations\/BaseAnimation";
import * as import_4 from ".\/themes\/dmon\/scripts\/animations\/BaseAnimations";
import * as import_5 from ".\/themes\/dmon\/scripts\/animations\/GroupAnimation";
import * as import_6 from ".\/themes\/dmon\/scripts\/animations\/HeightAnimation";
import * as import_7 from ".\/themes\/dmon\/scripts\/engines\/AbstractEngine";
import * as import_8 from ".\/themes\/dmon\/scripts\/engines\/JQueryEngine";
import * as import_9 from ".\/themes\/dmon\/scripts\/engines\/WebAnimationEngine";
import * as import_10 from ".\/themes\/dmon\/scripts\/widgets\/Checkbox";
import * as import_11 from ".\/themes\/dmon\/scripts\/widgets\/Select";
import * as import_12 from ".\/themes\/dmon\/scripts\/widgets\/TextInput";
export const imports={
...import_1,
...import_2,
...import_3,
...import_4,
...import_5,
...import_6,
...import_7,
...import_8,
...import_9,
...import_10,
...import_11,
...import_12,
}
